
/* eslint-disable no-use-before-define */
import React from 'react'
import { parseHtml } from '../../twd/parse.js'
import { getMarketCheckData } from './get-market-check-data.js'
import { Loading } from './loading.js'

export const Loader = ({
    askId,
    askPrice,
    askQuantity,
    highYieldInd,
    holdCusip,
    holdInvType,
}) => {
    const [status, setStatus] = React.useState('loading')
    const [marketcheckData, setMarketcheckData] = React.useState(null)

    React.useEffect(() => {
        let cancelled = false

        ;(async () => {
            let data_ = await getMarketCheckData({
                askId,
                askPrice,
                askQuantity,
                highYieldInd,
                holdCusip,
                holdInvType,
            })
            if (cancelled) return

            if (data_===undefined) {
                setStatus('failed')
                return
            }


            if (!data_) {
                setStatus('not-found')
                return
            }

            setStatus('found')
            setMarketcheckData(data_)
        })()

        return () => {
            cancelled = true
        }
    }, [])

    return <React.Fragment>
        <div className="container">
        { status==='loading' ? <Loading />
        : status==='found' ? <div dangerouslySetInnerHTML={{__html:parseHtml(marketcheckData)}} />
        : null }
        </div>
    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/offerings/market-check/loader.js